// extracted by mini-css-extract-plugin
module.exports = {"container":"time-modal_container__3JkCw","number":"time-modal_number__1K0pN","inputNumber":"time-modal_inputNumber__1ubm1","word":"time-modal_word__261La"};